import { ajvResolver } from '@hookform/resolvers/ajv'
import { useAuth } from 'contexts/auth'
import { useCustomTheme } from 'contexts/theme'
import { useCallback, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import InviteResponsibleSchema, { IInviteResponsibleFormData } from 'schema/authentication/invite-responsible'
import api from 'services/api'

const useComponent = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [mainError, setMainError] = useState('')

  const { theme } = useCustomTheme()

  const { user } = useAuth()
  const history = useHistory()

  const form = useForm<IInviteResponsibleFormData>({
    resolver: ajvResolver(InviteResponsibleSchema),
  })

  const onSubmit = useCallback(
    async (data: IInviteResponsibleFormData) => {
      try {
        setIsLoading(true)

        if (!user) {
          setIsLoading(false)
          setMainError('Usuário não encontrado!')
          return
        }

        const payLoad = {
          userId: user.id,
          cnpj: user.organization?.cnpj,
          email: user.email,
          responsibleEmail: data.responsibleEmail,
          responsibleName: data.responsibleName,
        }

        await api.post('/passwords/invite', payLoad)

        setIsLoading(false)
        history.push('/invite-responsible-success')
      } catch (err) {
        setIsLoading(false)
        setMainError('Erro ao solicitar reset de senha!')
      }
    },
    [history]
  )

  const handleChange = (formField: any) => {
    setMainError('')
  }

  const handleBack = () => {
    history.push('/esocial-connect')
  }

  return {
    theme,
    form,
    isLoading,
    onSubmit,
    handleChange,
    handleBack,
  }
}

export default useComponent
